<template>
  <body style="max-width:1000px;margin:0 auto;">
    <div>
      <van-empty image="search" :description="hauce_errmsg" v-show="huace_status === 0"></van-empty>



      <div v-show="huace_status !== 0">


        <div class="web-player-wrapper" v-show="is_show_video ==1" ref="playerWrapper">
          <video v-show="is_m3u8" id="video" ref="video" width="100%" height="auto" controls="controls"
            autoplay="autoplay" x-webkit-airplay="true" :poster="[poster]" x5-video-player-fullscreen="true"
            preload="auto" playsinline="true" webkit-playsinline x5-video-player-typ="h5">
            <source type="application/x-mpegURL" :src="[gooodinfo.video_url]">
          </video>

          <video v-show="!is_m3u8" width="100%" height="auto" controls="controls" autoplay="autoplay"
            :src="[gooodinfo.video_url]"> </video>

        </div>



        <loading v-if="is_loading" />
        <div class="detail" v-else>
          <div class="Seasoning">
            <div class="good-extra-info" v-if="showExtraInfo">
              <div class="good-extra-info__title">基础信息</div>
              <div class="good-extra-info__row" v-if="hasText(gooodinfo.goodsname)">
                <div class="good-extra-info__label">产品名称</div>
                <div class="good-extra-info__value">{{ gooodinfo.goodsname }}</div>
              </div>
              <div class="good-extra-info__row" v-if="hasText(gooodinfo.net_content)">
                <div class="good-extra-info__label">净含量</div>
                <div class="good-extra-info__value">{{ gooodinfo.net_content }}</div>
              </div>
              <div class="good-extra-info__row" v-if="hasText(gooodinfo.origin_place)">
                <div class="good-extra-info__label">产地</div>
                <div class="good-extra-info__value">{{ gooodinfo.origin_place }}</div>
              </div>
              <div class="good-extra-info__row" v-if="hasText(gooodinfo.production_date)">
                <div class="good-extra-info__label">生产日期</div>
                <div class="good-extra-info__value">{{ gooodinfo.production_date }}</div>
              </div>
              <div class="good-extra-info__row" v-if="hasText(gooodinfo.shelf_life)">
                <div class="good-extra-info__label">保质期</div>
                <div class="good-extra-info__value">{{ gooodinfo.shelf_life }}</div>
              </div>
              <div class="good-extra-info__detail" v-if="hasText(gooodinfo.goods_detail_text)">
                <div class="good-extra-info__detail-title">详情</div>
                <div class="good-extra-info__detail-text">{{ gooodinfo.goods_detail_text }}</div>
              </div>
            </div>
            <div class="goodspc" v-html="goodspc" v-lazy-container="{ selector: 'img' }">
              {{ goodspc }}
            </div>

            <div  :style="{ color:theme_info.out_url_font_color ,background:theme_info.out_url_bg_color,textOverflow: 'clip', overflow: 'hidden'}"  class="go_out"   v-if="gooodinfo.out_url"
              @click="go_out(gooodinfo.out_url)">
              {{ theme_info.out_url_name }}
            </div>
            <div class="back" @click="backNav">返回首页</div>
            <div class="top" v-if="btnFlag" @click="backTop">返回顶部</div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
  //import videojs from "video.js";
  //import "videojs-contrib-hls";
  import wx from "weixin-js-sdk";
  export default {
    data() {
      return {
        //v-if为true显示，false消失
        btnFlag: false,
        //记录屏幕滑动的值
        scrollTop: 0,
        gooodinfo: "",
        goodspc: "",
        is_loading: true,
        huace_id: "",
        theme_info:{},
        type: '0',
        is_flv: 0,
        is_hls: 0,
        is_m3u8: 1,
        poster: '',
        hls: null,
        huace_status: "1",
        hauce_errmsg: "",
        is_show_video: 0
      };
    },

    // vue的两个生命钩子，这里不多解释。
    //mounted是vue已经加载好了；destroyed是vue已经销毁了
    // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
    mounted: function() {
      window.addEventListener("scroll", this.scrollToTop);
    },
    destroyed: function() {
      let app = this;
      window.removeEventListener("scroll", this.scrollToTop);
      //用于注销全部注册事件并销毁视频，在页面组件销毁前可调用此方法来释放内存。
      app.videoPause();

    },
    computed: {
      showExtraInfo() {
        const info = this.gooodinfo || {};
        if (Number(info.is_good_extra_fields) !== 1) {
          return false;
        }
        return [
          info.goodsname,
          info.net_content,
          info.origin_place,
          info.production_date,
          info.shelf_life,
          info.goods_detail_text,
        ].some((value) => this.hasText(value));
      },
    },

    methods: {
      hasText(value) {
        return value !== null && value !== undefined && String(value).trim() !== "";
      },
      init_video() {
        let app = this;
        let type = app.type;
        console.log('type', type);
        if (type == '0') {
          //this.$(".web-player-wrapper").attr("style", "visibility: hidden;height:0;");
          // 在Vue实例的方法或钩子中操作
          //this.$refs.playerWrapper.style.visibility = 'hidden';
          //this.$refs.playerWrapper.style.height = '0';
          app.is_show_video = 0;
          return;
        } else if (type == '1') {
          app.goodspc = '';
        }

        //判断后缀是啥文件支持m3u8，flv以及mp4格式的
        let url = app.gooodinfo.video_url;
        // 检查 url 是否为空或 null
        if (!url) {
          console.log("url", url);
          console.error('URL is empty or null');
          return;
        }

        const fileName = url.substring(url.lastIndexOf('/') + 1);
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
        if (fileExtension === 'm3u8') {
          console.log('文件名后缀是.m3u8');
          app.is_m3u8 = 1;
        } else if (fileExtension === 'flv') {
          console.log('文件名后缀是.flv');
          app.is_m3u8 = 0;
        } else {
          console.log('文件名后缀是.' + fileExtension);
          app.is_m3u8 = 0;
        }


        //this.$(".web-player-wrapper").attr("style", "visibility: visible");
        /*
        this.$refs.playerWrapper.style = {
          visibility: 'visible',
          height: 'auto'
        };
        */
        app.is_show_video = 1;


        console.log('是否支持HLS', Hls.isSupported())
        console.log('浏览器信息, window.navigator.userAgent: ', window.navigator.userAgent);

        app.hls = new Hls()
        app.hls.loadSource(app.gooodinfo.video_url)
        //app.poster = app.gooodinfo.goods_thumb;
        app.hls.attachMedia(app.$refs.video)
        app.hls.on(Hls.Events.MANIFEST_PARSED, function() {
          app.$refs.video.play();
        })

        app.hls.on(Hls.Events.ERROR, (event, data) => {
          console.log(event, data);
          // 监听出错事件
        })



      },
      // 停止流
      videoPause() {
        let app = this;
        if (app.hls) {
          app.hls.destroy();
          app.hls = null;
        }
      },
      backNav() {
        var id = this.$route.query.id;

        if (window.history.length <= 1) {
          this.$router.push({
            path: "/",
            query: {
              id: id,
            },
          });
          return false;
        } else {
          this.$router.back();
          return false;
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了
        setTimeout(() => {
          this.$router.push({
            path: "/",
            query: {
              id: id,
            },
          });
        }, 500);
      },
      // 点击图片回到顶部方法，加计时器是为了过渡顺滑
      backTop() {
        var timer = setInterval(function() {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          this.isTop = true;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 30);
      },
      //跳转外部链接
      go_out(url) {
        window.location.href = url;
      },

      // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
      scrollToTop() {
        const that = this;
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        that.scrollTop = scrollTop;
        if (that.scrollTop > 0) {
          that.btnFlag = true;
        } else {
          that.btnFlag = false;
        }
      },
      initShow: function() {
        const app = this;
        let goods_id = this.$route.query.goods_id;
        let huace_id = this.$route.query.id;

        var token = localStorage.getItem("token");
        this.$http
          .get(
            api_url +
            `action=get_goodinfo&g_id=${goods_id}&token=${token}&id=${huace_id}`
          )
          .then((res) => {

            //如果失败了
            if (res.data.sta != 200) {
              this.huace_status = 0;
              this.hauce_errmsg = res.data.msg;
              return;
            }

            this.gooodinfo = res.data.res;
            this.goodspc = res.data.res.goodspc;
            this.type = res.data.res.type;
            //设置网页标题
            document.title = res.data.res.goodsname;
            app.is_loading = false;
            //微信分享
            this.wechatShare();
            //初始化视频
            this.init_video();

          })
          .catch(function(error) {
            console.log(error);
          });
      },
      //微信分享
      wechatShare() {
        var app = this;
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        //必须要url编码，如果不变吗，url的参数值里面有&拼接会被当做接口参数以及参数值，再次发送
        let url = encodeURIComponent(window.location.href);
        var pathUrl =
          api_url + `action=get_wxshare_param&id=${id}&token=${token}&url=${url}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {
            console.log("get_wxshare_param", res);
            if (res.data.sta == 200) {
              let data = res.data;
              //通过config接口注入权限验证配置
              wx.config({
                debug: data.res.is_debug_fx,
                appId: data.res.appId,
                timestamp: data.res.timestamp,
                nonceStr: data.res.nonceStr,
                signature: data.res.signature,
                jsApiList: [
                  "updateTimelineShareData",
                  "updateAppMessageShareData",
                  "showAllNonBaseMenuItem",
                  "hideAllNonBaseMenuItem",
                  "showMenuItems",
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline",
                ],
              });
              //console.log(data.res.appId)
              //console.log(data.res.timestamp)
              //console.log(data.res.nonceStr)
              // console.log(data.res.signature)

              //预处理下分享数据
              let share_title = "";
              let share_desc = "";
              let share_img = "";

              console.log("app.gooodinfo", app.gooodinfo);
              //商品分享标题设置取设置，否则取商品名称
              if (!!app.gooodinfo.share_title) {
                share_title = app.gooodinfo.share_title;
              } else {
                share_title = app.gooodinfo.goodsname;
              }
              //商品描述设置取设置，否则取模板上面的
              if (!!app.gooodinfo.share_desc) {
                share_desc = app.gooodinfo.share_desc;
              } else {
                share_desc = data.res.share_desc;
              }
              //商品设置取商品设置，否则取商品缩略
              if (!!app.gooodinfo.share_img) {
                share_img = app.gooodinfo.share_img;
              } else {
                share_img = app.gooodinfo.goods_thumb;
              }

              //给去购买按钮赋值
              app.theme_info=data.res.theme_info;

              //通过ready接口处理成功验证
              wx.ready(function() {
                //展示所有基础类型按钮，20211012日，微信增加了直接访问网址，出现一个拦截，这种情况下不显示分享按钮，先收藏然后在分享就可以，bug
                wx.showAllNonBaseMenuItem();
                /*
                wx.hideAllNonBaseMenuItem();
                wx.showMenuItems({
                  menuList: ["menuItem:share:appMessage", "menuItem:share:timeline",
                    "updateAppMessageShareData", "updateAppMessageShareData"
                  ] // 要显示的菜单项，所有menu项见附录3
                });*/
                /*
                //注释掉新版，旧的才会生效
                wx.updateAppMessageShareData({
                  title: app.gooodinfo.goodsname,
                  desc: data.res.share_desc,
                  link: window.location.href,
                  imgUrl: app.gooodinfo.goods_thumb,
                  success: function() {
                    console.log("设置成功")
                  },
                  cancel: function(res) {
                    console.log('分享失败');
                  },
                  complete: function(res) {
                    console.log("complete1");
                  },
                  trigger: function(res) {
                    console.log("trigger1");
                  }
                })
                wx.updateTimelineShareData({
                  title: app.gooodinfo.goodsname,
                  desc: data.res.share_desc,
                  link: window.location.href,
                  imgUrl: app.gooodinfo.goods_thumb,
                  success: function(res) {
                    console.log('设置成功');
                  },
                  cancel: function(res) {
                    console.log('分享失败');
                  },
                  complete: function(res) {
                    console.log("complete2");
                  },
                  trigger: function(res) {
                    console.log("trigger2");
                  }
                });
                */
                //旧的版本还有分享成功回调。不过不知道能用多久还
                wx.onMenuShareAppMessage({
                  title: share_title, // 分享标题
                  desc: share_desc, // 分享描述
                  link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: share_img, // 分享图标
                  type: "", // 分享类型,music、video或link，不填默认为link
                  dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了1")
                    var link = escape(window.location.href);
                    var desc = share_desc;
                    var title = share_title;
                    var imgUrl = share_img;
                    var share_type = "1";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
                wx.onMenuShareTimeline({
                  title: share_title, // 分享标题
                  link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: share_img, // 分享图标
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了2")
                    var link = escape(window.location.href);
                    var desc = "";
                    var title = share_title;
                    var imgUrl = share_img;
                    var share_type = "2";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
              });
            }
          });
      },
    },

    created: function() {
      //初始化
      this.initShow();
    },
  };
</script>

<style scoped>
  .web-player-wrapper {
    background: black;
    width: 100%;
    height: auto;
    /*margin:5px auto;*/
  }

  #player {
    height: auto !important;
  }



  * {
    margin: 0;
    padding: 0;
  }

  .Seasoning {
    width: 100%;
    /*height: 100%;*/
    /*overflow-y: scroll;*/
    background-color: #fff;
  }

  .Seasoning p {
    font-size: 18px;
    color: rgb(127, 127, 127);
    font-family: "微软雅黑";
  }

  .Seasoning img {
    width: 100%;
    height: 100%;
  }

  * .top {
    width: 3.75rem;
    height: 3.75rem;
    line-height: 3.75rem;
    text-align: center;
    font-size: 12px;
    font-family: "微软雅黑";
    color: #fff;
    border-radius: 50%;
    background: rgba(17, 221, 187, 0.4);
    float: right;
    position: fixed;
    bottom: 4.825rem;
    right: 0.625rem;
  }

  .back {
    width: 3.75rem;
    height: 3.75rem;
    line-height: 3.75rem;
    text-align: center;
    font-size: 12px;
    font-family: "微软雅黑";
    color: #fff;
    border-radius: 50%;
    background: rgba(17, 221, 187, 0.4);
    float: right;
    position: fixed;
    bottom: 0.625rem;
    right: 0.625rem;
  }

  .go_out {
    width: 3.75rem;
    height: 3.75rem;
    line-height: 3.75rem;
    text-align: center;
    font-size: 12px;
    font-family: "微软雅黑";
    color: #fff;
    border-radius: 50%;
    background: rgba(17, 221, 187, 0.4);
    float: right;
    position: fixed;
    bottom: 50%;
    right: 0.625rem;
  }

  .can p {
    font-size: 0.75rem;
    font-family: "微软雅黑";
    color: #000000;
  }

  .good-extra-info {
    margin: 0.75rem;
    padding: 0.875rem 1rem;
    background: #fff;
    border-radius: 0.75rem;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .good-extra-info__title {
    margin-bottom: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    color: #222;
  }

  .good-extra-info__row {
    display: flex;
    align-items: flex-start;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f2f3f5;
  }

  .good-extra-info__row:last-of-type {
    border-bottom: none;
  }

  .good-extra-info__label {
    width: 4.75rem;
    flex-shrink: 0;
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: #909399;
  }

  .good-extra-info__value {
    flex: 1;
    min-width: 0;
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: #303133;
    word-break: break-all;
  }

  .good-extra-info__detail {
    padding-top: 0.75rem;
  }

  .good-extra-info__detail-title {
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: #909399;
  }

  .good-extra-info__detail-text {
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: #303133;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .goodspc>>>img {
    width: 100% !important;
    /*margin-top: -4px;*/
  }

  .goodspc>>>p {
    margin: 0px;
    padding: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
    /*margin-top: -1px;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/detail.vue